import * as React from 'react'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import CloseIcon from '@mui/icons-material/Close'
import IconButton from '@mui/material/IconButton'
import SwipeableDrawer from '@mui/material/SwipeableDrawer'
import { gradient } from 'src/assets/images'
import { NavLinksAllExposed } from 'src/components/molecules/NavLinks'
import Logo from 'src/components/atoms/Logo'
import { NavigationDocumentDataBodyLinksSliceItem, NavigationDocumentDataBodyButtonsSliceItem } from '../../../../types.generated'
import NavigationButtons from './../../molecules/NavigationButtons/NavigationButtons'

interface Props {
  toggleDrawer: (arg1: boolean) => void
  open: boolean
  closeDrawer: () => void
  links: NavigationDocumentDataBodyLinksSliceItem[]
  buttons: NavigationDocumentDataBodyButtonsSliceItem[]
}

const SideBar: React.FC<Props> = ({ toggleDrawer, open, closeDrawer, links, buttons }) => {
  const iOS =
    typeof navigator !== 'undefined' &&
    /iPad|iPhone|iPod/.test(navigator.userAgent)
  return (
    <SwipeableDrawer
      sx={{
        '& .MuiDrawer-paper': {
          width: '100vw',
          boxSizing: 'border-box',
        },
      }}
      anchor="right"
      disableBackdropTransition={!iOS}
      disableDiscovery={iOS}
      open={open}
      onClose={() => toggleDrawer(false)}
      onOpen={() => toggleDrawer(true)}
      PaperProps={{
        sx: {
          p: 2,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          background: `url(${gradient});`,
        },
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Box sx={{ minWidth: 86, width: 86, pt: 1 }}>
          <Logo />
        </Box>
        <IconButton
          color="inherit"
          aria-label="open drawer"
          onClick={closeDrawer}
          edge="start"
        >
          <CloseIcon color="primary" />
        </IconButton>
      </Box>
      <Stack spacing={3} sx={{ textAlign: 'center' }}>
        <NavLinksAllExposed variant="h6" links={links} />
      </Stack>
      <NavigationButtons buttons={buttons} />
    </SwipeableDrawer>
  )
}

export default SideBar
